'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4,
    _t5;

import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import * as CurrencyCodes from 'self-service-api/constants/CurrencyCodes';
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import UISelectableBox from 'UIComponents/button/UISelectableBox';
import { activeCurrencySelector, availableCurrenciesSelector } from 'pricing-pages-unified-ui/selectors/CurrencySelectors';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { updateActiveCurrencyCode } from 'pricing-pages-unified-ui/actions/ActiveCurrencyCodeActions';
import { getGAClassName } from 'pricing-pages-lib/utils/publicPageUrls';
import breakpoint from '../../utils/responsiveBreakpoints';
import { breakpointValues, minWidthBreakpoint } from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
const CurrencyCodeToSymbol = {
  [CurrencyCodes.USD]: '$',
  [CurrencyCodes.EUR]: '€',
  [CurrencyCodes.GBP]: '£',
  [CurrencyCodes.AUD]: '$',
  [CurrencyCodes.JPY]: '¥',
  [CurrencyCodes.SGD]: '$',
  [CurrencyCodes.COP]: '$',
  [CurrencyCodes.CAD]: '$'
};
const CurrencySelectorWrapper = styled.div.withConfig({
  displayName: "CurrencyPicker__CurrencySelectorWrapper",
  componentId: "kpjh2t-0"
})(["position:sticky;top:25%;z-index:2;", ";", ";.currency-symbol{margin-left:2px;", "}"], breakpoint.tablet(_t || (_t = _`
    position: static;
    top: initial;
    text-align: center;
    background-color: #f5f8fa;
  `)), breakpoint.phone(_t2 || (_t2 = _`
    padding: 0 15px;
    .currency-symbol {
      display: none;
    }
  `)), breakpoint.phone(_t3 || (_t3 = _`
      display: none;
    `)));
const StyledButtonGroup = styled(UIButtonGroup).withConfig({
  displayName: "CurrencyPicker__StyledButtonGroup",
  componentId: "kpjh2t-1"
})(["position:absolute;margin-top:100px;z-index:2;", ";"], breakpoint.tablet(_t4 || (_t4 = _`
    position: static;
    margin: 1.4em 0;
  `)));
const StyledSelectableBox = styled(UISelectableBox).withConfig({
  displayName: "CurrencyPicker__StyledSelectableBox",
  componentId: "kpjh2t-2"
})(["z-index:5;:hover{z-index:6;}.currency-selector__text{font-size:12px;}", " ", ""], minWidthBreakpoint.tablet(_t5 || (_t5 = _`
    border-left: 0 !important;

    &:first-child {
      border-top-left-radius: 0;
    }

    &:last-child {
      border-bottom-left-radius: 0;
    }
  `)), ({
  selected
}) => selected && css(["z-index:6;"]));

const windowWidthIsMobile = () => window.innerWidth <= breakpointValues.tablet;

const CurrencyPicker = ({
  availableCurrencies,
  activeCurrencyCode,
  onUpdateActiveCurrencyCode
}) => {
  const handleClick = currency => {
    onUpdateActiveCurrencyCode(currency);
    getUsageTracker().track('selectCurrency', {
      currency
    });
  };

  const [isMobile, setIsMobile] = useState(windowWidthIsMobile());
  useEffect(() => {
    const mobileCheck = () => {
      if (windowWidthIsMobile() !== isMobile) setIsMobile(windowWidthIsMobile());
    };

    window.addEventListener('resize', mobileCheck);
    return () => window.removeEventListener('resize', mobileCheck);
  }, [isMobile]);
  return availableCurrencies.length <= 1 ? null : /*#__PURE__*/_jsx(CurrencySelectorWrapper, {
    children: /*#__PURE__*/_jsx(StyledButtonGroup, {
      orientation: isMobile ? 'horizontal' : 'vertical',
      className: 'currency-selector__button-group',
      children: availableCurrencies.map(currency => {
        const selected = activeCurrencyCode === currency;
        const gaClassName = getGAClassName(`currency-pricing-${currency.toLowerCase()}`);
        return /*#__PURE__*/_jsx(StyledSelectableBox, {
          selected: selected,
          onClick: () => handleClick(currency),
          className: `p-all-2 ${gaClassName}`,
          "data-selenium-id": gaClassName,
          children: /*#__PURE__*/_jsxs("span", {
            className: `currency-selector__text ${gaClassName}`,
            children: [currency, /*#__PURE__*/_jsx("span", {
              className: "currency-symbol",
              children: CurrencyCodeToSymbol[currency]
            })]
          })
        }, currency);
      })
    })
  });
};

CurrencyPicker.propTypes = {
  availableCurrencies: PropTypes.array.isRequired,
  activeCurrencyCode: PropTypes.oneOf(Object.values(CurrencyCodes || {})),
  onUpdateActiveCurrencyCode: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    availableCurrencies: availableCurrenciesSelector(state),
    activeCurrencyCode: activeCurrencySelector(state)
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateActiveCurrencyCode: currency => dispatch(updateActiveCurrencyCode({
    currency
  }))
});

export default connect(mapStateToProps, mapDispatchToProps)(CurrencyPicker);